import axios from 'axios'

const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://edenplaisir.local:8443/api'

export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/ld+json',
  },
  withCredentials: true, // Envoyer les cookies (dont le refresh_token) avec chaque requête
})

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth-storage')
    if (token) {
      try {
        const authData = JSON.parse(token)
        if (authData.state?.token) {
          config.headers.Authorization = `Bearer ${authData.state.token}`
        }
      } catch (error) {
        console.error('Error parsing auth token:', error)
      }
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor to handle token refresh
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true

      try {
        const token = localStorage.getItem('auth-storage')
        if (token) {
          const authData = JSON.parse(token)
          
          // Appel à l'endpoint de refresh
          // Le refresh_token est envoyé automatiquement via le cookie HTTP-only
          const response = await axios.post(
            `${API_BASE_URL}/token/refresh`,
            {}, // Body vide car le refresh_token est dans le cookie
            {
              withCredentials: true, // Important : envoyer les cookies
            }
          )

          const { token: newToken } = response.data

          // Update le token JWT dans le localStorage
          const updatedAuthData = {
            ...authData,
            state: {
              ...authData.state,
              token: newToken,
              // Le refreshToken n'est plus stocké ici, il est dans le cookie HTTP-only
            },
          }
          localStorage.setItem('auth-storage', JSON.stringify(updatedAuthData))

          // Retry original request with new token
          originalRequest.headers.Authorization = `Bearer ${newToken}`
          return api(originalRequest)
        }
      } catch (refreshError) {
        // Refresh failed, redirect to login
        console.error('Échec du rafraîchissement du token:', refreshError)
        localStorage.removeItem('auth-storage')
        window.location.href = '/login'
      }
    }

    return Promise.reject(error)
  }
)

export default api
